module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Fire-5228bb5f6a14cd5086e03bbc3fa1296c.svg";